module.exports = __webpack_public_path__ + "static/logo-smart.95f86b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-smart.png
// module id = 234
// module chunks = 35783957827783 213720915766396